<template>
  <div class="ct-realisation">
    <div class="ct-realisation-content ct-resolution-width" v-if="realisation">
      <div class="ct-realisation-title">
        <h1>{{realisation.title}}</h1>
      </div>
      <div class="ct-realisation-pictures">
        <carousel :per-page="getPerPage()">
          <slide v-for="image in realisation.media.images" :key="image.name">
            <div class="ct-carousel-element">
              <img class="ct-carousel-element-image"
                   :src="getImgUrl(image.name, realisation.media.directory)">
            </div>
          </slide>
        </carousel>
      </div>
      <div>
        <router-link class="ct-clickable" to="/realisations" :class="{'ct-realisation-return-button': isOnePage()}">
            <button class="ct-bouton btn waves-effect waves-light" type="submit" name="action">
              <i class="material-icons left">arrow_back</i>
              Retour à la liste des réalisations
            </button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import { Carousel, Slide } from 'vue-carousel';
  import { getRealisation } from "../actions/realisationsData";
  import {getDirectoryForDevice} from "../actions/generalData";

  export default {
    name: 'CtRealisation',
    components: {
      Carousel,
      Slide
    },
    data() {
      return {
        realisation: {
          media: {}
        },
	  	deviceDirectory: '',
      }
    },
    methods: {
      getImgUrl(name, directory) {
        return require('../assets/' + this.deviceDirectory + directory + name)
      },
      getPerPage() {
          if(this.realisation.media.images && this.realisation.media.images.length !== 1 && screen.width>767) {
            return 2;
          }
          return 1
      },
      isOnePage() {
        return this.realisation.media.images && this.realisation.media.images.length <= 2
      }
    },
    mounted: function() {
      this.realisation = getRealisation(this.$route.params.id)[0];
		this.deviceDirectory = getDirectoryForDevice(screen.width)
    }
  }
</script>

<style scoped>

  .ct-realisation {
    display: flex;
    justify-content: center;
	  margin-bottom: 50px;
  }

  .ct-realisation-content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .ct-realisation-title {
    /*display: flex;*/
    /*justify-content: center;*/
    text-align: center;
  }

  .ct-realisation-pictures {
    width: 90%;
    margin: 50px;
  }

  .ct-carousel-element {
    display: flex;
    justify-content: center;
  }

  .ct-carousel-element-image {
    width: 90%;
    height: 100%;
  }

  .active {
    background-color: red;
  }

  .VueCarousel-dot button {
      background: red!important;
  }

</style>



// WEBPACK FOOTER //
// src/components/CtRealisation.vue